const mod = require('onyx-root/prop-types')
const requireOneOf = require('onyx-common/requireOneOf').default

module.exports = {
  ...mod,
  requireOneOf

}
